export const ctaBackgroundSettings = {
    src: "",
    align: "top",
    color: "transparent",
    default: true,
    border: {
        style: "none",
        width: 0,
        color: "transparent",
        radius: 0
    }
}
